import ChatRoomLayout from '@/components/layouts/chatroom-layout';
import useSessionEffect from '@/hooks/conversations/use-session-effect';
import { useMessageStore } from '@/stores/message';
import { parseSessionKey } from '@/utils/session';

export default function SessionMessagesLayout() {
  const id = useMessageStore((s) => parseSessionKey(s.key ?? '')[1]);
  useSessionEffect('session', id);

  return <ChatRoomLayout type='session' />;
}
